/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-12, 09:11:57
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-07-19, 13:49:17
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
import { checkIsUserSessionExist } from "actions/authorization";
import { hashHistory } from 'react-router';
const MAIN_REDIRECT_PAGE_AFTER_LOGIN = '/';

/**
 * Generate paths for the platform.
 *
 * @param {any} store
 * @returns
 */
const Routes = store => [
  {
    path: '/',
    getComponent(location, cb) {
      getPage('home/index', store, cb);
    }
  },
  {
    path: 'authorization/login',
    getComponent(location, cb) {
      checkUserSession(
        store,
        () => redirect(MAIN_REDIRECT_PAGE_AFTER_LOGIN),
        () =>  import(`routes/authorization`)
          .then(loadRoute(cb, true))
          .catch(errorLoading) 
      );
    }
  },
  {
    path: '/baners',
    getComponent(location, cb) {
      getPage('baners/index', store, cb);
    }
  },
  {
    path: '/baners/create',
    getComponent(location, cb) {
      getPage('baners/index', store, cb);
    }
  },
  {
    path: '/baners/update/:id',
    getComponent(location, cb) {
      getPage('baners/index', store, cb);
    }
  },
  {
    path: '/blackList',
    getComponent(location, cb) {
      getPage('blackList/index', store, cb);
    }
  },
  {
    path: '/blackList/create',
    getComponent(location, cb) {
      getPage('blackList/index', store, cb);
    }
  },
  {
    path: '/dictionary',
    getComponent(location, cb) {
      getPage('dictionary/index', store, cb);
    }
  },
  {
    path: '/dictionary/create',
    getComponent(location, cb) {
      getPage('dictionary/index', store, cb);
    }
  },
  {
    path: '/groups',
    getComponent(location, cb) {
      getPage('groups/index', store, cb);
    }
  },
  {
    path: '/groups/create',
    getComponent(location, cb) {
      getPage('groups/index', store, cb);
    }
  },
  {
    path: '/groups/update/:id',
    getComponent(location, cb) {
      getPage('groups/index', store, cb);
    }
  },
  {
    path: '/statuses',
    getComponent(location, cb) {
      getPage('statuses/index', store, cb);
    }
  },
  {
    path: '/statuses/create',
    getComponent(location, cb) {
      getPage('statuses/index', store, cb);
    }
  },
  {
    path: '/statuses/update/:id',
    getComponent(location, cb) {
      getPage('statuses/index', store, cb);
    }
  },
  {
    path: '/users',
    getComponent(location, cb) {
      getPage('users/index', store, cb);
    }
  },
  {
    path: '/users/create',
    getComponent(location, cb) {
      getPage('users/index', store, cb);
    }
  },
  {
    path: '/users/update/:id',
    getComponent(location, cb) {
      getPage('users/index', store, cb);
    }
  },
  {
    path: '/complains',
    getComponent(location, cb) {
      getPage('complains/index', store, cb);
    }
  },
  {
    path: '/recharges',
    getComponent(location, cb) {
      getPage('recharges/index', store, cb);
    }
  },
  {
    path: '/complains/categories',
    getComponent(location, cb) {
      getPage('complains/index', store, cb);
    }
  },
  {
    path: '/complains/categories/create',
    getComponent(location, cb) {
      getPage('complains/index', store, cb);
    }
  },
  {
    path: '/complains/categories/update/:id',
    getComponent(location, cb) {
      getPage('complains/index', store, cb);
    }
  },
  {
    path: '/complains/titles',
    getComponent(location, cb) {
      getPage('complains/index', store, cb);
    }
  },
  {
    path: '/complains/titles/create',
    getComponent(location, cb) {
      getPage('complains/index', store, cb);
    }
  },
  {
    path: '/complains/titles/update/:id',
    getComponent(location, cb) {
      getPage('complains/index', store, cb);
    }
  },
  {
    path: '/clients',
    getComponent(location, cb) {
      getPage('clients/index', store, cb);
    }
  },
  {
    path: '/clients/details/:id',
    getComponent(location, cb) {
      getPage('clients/index', store, cb);
    }
  },
  {
    path: '/confirmation',
    getComponent(location, cb) {
      getPage('confirmation/index', store, cb);
    }
  },
  {
    path: '/*',
    getComponent(location, cb) {
        import('routes/notFound').then(loadRoute(cb, true)).catch(errorLoading);
    }
  }
];

export default Routes;
// =============================================================================
// Support functions.
// =============================================================================
/**
 * Load a container.
 *
 * @param {string} [container=""]
 * @param {any} [store={}]
 * @param {any} [cb=() => {}]
 */
function getPage(container = '', store = {}, cb = () => {}) {
  checkUserSession(
    store,
    async () => {
      import(`routes/${container}`)
        .then(loadRoute(cb, true))
        .catch(errorLoading);
    },
    false,
  );
}

/**
 * Verify that the user is logged on.
 *
 * @param {any} [store={}]
 * @param {any} [cb={}]
 */
function checkUserSession(store = {}, success = {}, error = () => {}) {
  let errorReponse = !error? () => redirect('/authorization/login') : error;
  store
    .dispatch(checkIsUserSessionExist())
    .then(result => success())
    .catch(() => errorReponse());
}

/**
 * Routing routing.
 *
 * @param {string} [site='']
 */
function redirect(site = '') {
  hashHistory.push(site);
}

/**
 * Error displaying when routing is loaded.
 *
 * @param {any} [err={}]
 */
function errorLoading(err = {}) {
  console.error('Dynamic page loading failed', err);
}

/**
 * Load a page.
 *
 * @param {any} cb
 * @returns
 */
function loadRoute(cb) {
  return (module) => {
    cb(null, module.default);
  };
}


// WEBPACK FOOTER //
// ./src/rcapp/routes.js